module.exports = __webpack_public_path__ + "img/手机点击旋转.90ae0849.png";